import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

class CategoriesList extends Component {
  render() {
    const {
      categories,
      selectedCategory,
      selectedSubCategory,
      itPopulerCars,
      car_type_id,
      car_brand_id,
      brand,
    } = this.props;
    const subCategories = categories.find(
      (category) => category.id === selectedCategory
    );

    return (
      <div className='categoriesList'>
        <div className='mainCategory'>
          <Swiper slidesPerView={2} spaceBetween={10}>
            {categories.map((category, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={
                    itPopulerCars
                      ? `/popular_cars/${car_type_id}/${car_brand_id}/${category.id}`
                      : `/brand/${brand}/${category.id}`
                  }>
                  <div
                    className={`categoryBox ${
                      selectedCategory === category.id ? "active" : ""
                    }`}>
                    <div className='categoryImg'>
                      <img src={category.image} alt={category.name} />
                    </div>
                    <span className='categoryTitle'>{category.name}</span>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className='subCategoryList'>
          <Swiper slidesPerView={2} spaceBetween={10}>
            {subCategories?.children.map((subCategory, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={
                    itPopulerCars
                      ? `/popular_cars/${car_type_id}/${car_brand_id}/${subCategories.id}/${subCategory.id}`
                      : `/brand/${brand}/${subCategory.id}`
                  }>
                  <div
                    className={`subCategoryBox ${
                      selectedSubCategory === subCategory.id ? "active" : ""
                    }`}>
                    {subCategory.name}
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  }
}
export default CategoriesList;
